import { render, staticRenderFns } from "./CompanyEmployeeForm.vue?vue&type=template&id=3f4a4b48&scoped=true&lang=pug&"
import script from "./CompanyEmployeeForm.vue?vue&type=script&lang=js&"
export * from "./CompanyEmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEmployeeForm.vue?vue&type=style&index=0&id=3f4a4b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a4b48",
  null
  
)

export default component.exports